export async function loadImage(source: string): Promise<Event> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', resolve);
    img.addEventListener('error', reject);
    img.src = source;
  });
}

export async function loadImages(sources: string[]): Promise<Event[]> {
  return Promise.all(sources.map(async source => loadImage(source)));
}
